<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>实名认证管理</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :inline="true" ref="formInline" :model="formInline" class="demo-form-inline">
            <el-form-item label="昵称" prop="nickName">
                <el-input v-model="formInline.nickName" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="username">
                <el-input v-model="formInline.username" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="Search">查询</el-button>
                <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form>
    
        <el-table :data="fetchList">
            <el-table-column prop="userId" label="ID">
            </el-table-column>
            <el-table-column prop="userManage.nickName" label="昵称">
            </el-table-column>
            <el-table-column prop="userManage.username" label="手机号">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="申请时间">
                <span v-if="row.applyDate">{{ new Date(row.applyDate).getFullYear()+'-'+(new Date(row.applyDate).getMonth()+1)+'-'+new Date(row.applyDate).getDate()+' '+new Date(row.applyDate).getHours()+':'+new Date(row.applyDate).getMinutes()+':'+new Date(row.applyDate).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="status" label="状态">
                <div>
                    <span v-if="row.status === 1">等待审核</span>
                    <span v-if="row.status === 3">未通过</span>
                    <span v-if="row.status === 2">通过</span>
                </div>
    
            </el-table-column>
            <el-table-column inline-template :context="_self" fixed="right" width="200" label="操作" v-if="Role === '1'">
                <span>
                                <el-button @click="handleChange($index, row)" type="text" size="small">审核</el-button>
                            </span>
            </el-table-column>
        </el-table>
    
    </div>
</template>

<script>
    import {
        getIdentification,
        filterUser
    } from '../../api/version'
    
    export default {
        data() {
            return {
                Role: sessionStorage.power,
                fetchList: [],
                formInline: {
                    nickName: '',
                    username: '',
                    dayStart: '',
                    dayEnd: '',
                },
    
            }
        },
    
        created() {
            getIdentification(sessionStorage.userId, JSON.stringify({
                "include": "userManage",
                "order": "userId desc",
                "where": {
                    "status": 1
                }
            })).then(res => {
                console.log(res.data)
                this.fetchList = res.data
            })
    
        },
    
        methods: {
            resetForm(formName) {
                this.formInline = {
                    nickName: '',
                    username: ''
                }
                this.$refs[formName].resetFields();
            },
    
            handleChange(index, row) {
                //审核
                this.$router.push('/changeIdentified/' + row.userId)
            },
            Search() {
                //搜索
                let data = {}
    
                this.formInline.nickName ? data.nickName = {
                    'like': '%25' + this.formInline.nickName + '%25'
                } : ''
                this.formInline.username ? data.username = {
                    'like': '%25' + this.formInline.username + '%25'
                } : ''
    
                if (data.nickName || data.username) {
                    filterUser(sessionStorage.userId, JSON.stringify({
                        'where': data
                    })).then(res => {
                        if (res.data && res.data.length) {
                            this.fetchList = []
                            res.data.forEach(item => {
                                let userId = item.userId
                                let search = {
                                    'include': 'userManage',
                                    "order": "userId desc",
                                    'where': {
                                        userId: userId,
                                        status: '1'
                                    }
                                }
                                getIdentification(sessionStorage.userId, JSON.stringify(search)).then(res => {
                                    if(res.data.length) {
                                        this.fetchList.push(res.data[0]) 
                                    }
                                    
                                }, err => {
                                    console.log(err)
                                })
                            })
    
                        } else {
                            this.fetchList = []
                        }
                    })
                } else {
                    getIdentification(sessionStorage.userId, JSON.stringify({
                        "include": "userManage",
                        "order": "userId desc",
                        "where": {
                            "status": 1
                        }
                    })).then(res => {
                        console.log(res.data)
                        this.fetchList = res.data
                    })
                }
    
    
    
    
            },
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// Identified.vue?57a77a43